// extracted by mini-css-extract-plugin
export default {"header":"hArrXz","logo":"v8hpKK","searchInput":"AgYcD8","closeButton":"VaisgQ"};